import cookies from "browser-cookies"
import * as tagging from "../tagging"
import logger from "@/core/logger"
import { Order } from "../types"
import { nostojs } from "../api"
import { Violation } from "@/order/track"

function populateOrderTagging(checkout: Order) {
  tagging.updateOrderTagging(checkout)
  tagging.updatePageTypeTagging("order")
}

export default () => {
  const sessionId = cookies.get("2c.cId")
  if (!sessionId) {
    return false
  }

  if (!sessionId || !window.Shopify) {
    return false
  }

  const { checkout } = window.Shopify

  if (!checkout || !checkout.order_id || !checkout.line_items) {
    return false
  }
  if (checkout.source_name === "shopify_draft_order") {
    console.warn("Dropping draft order")
    return false
  }

  // add order tagging and page type tagging to the page
  // @ts-expect-error type mismatch
  populateOrderTagging(checkout)

  function getShopifyCheckout() {
    const { credit_card, billing_address, shipping_address, email, ...rest } = window.Shopify.checkout
    return rest
  }

  // add listener for errors
  nostojs(api =>
    api.listen("ordererror", orderError => {
      try {
        const serverMessage = []
        serverMessage.push("Invalid order tagging, validation errors:")
        orderError.response.errors.forEach((violation: Violation) => {
          const { key, message_key } = violation
          serverMessage.push(` • ${key}: ${message_key}`)
        })
        serverMessage.push(` Order Payload: ${JSON.stringify(orderError.payload)}`)
        serverMessage.push(` Shopify.checkout: ${JSON.stringify(getShopifyCheckout())}`)
        logger.error(serverMessage.join("\n"))
      } catch (e) {
        logger.error("Error when submitting invalid order error", e)
      }
    })
  )
  // add ev1end listener and log an error if the tagging doesn't find order tagging but Shopify object has one
  nostojs(api =>
    api.listen("ev1end", () => {
      try {
        const tagging = api.pageTagging()
        if (!tagging.order) {
          const serverMessage = []
          serverMessage.push("Missed order because order tagging not found:")
          serverMessage.push(` pageTagging: ${JSON.stringify(tagging)}`)
          serverMessage.push(` Shopify.checkout: ${JSON.stringify(getShopifyCheckout())}`)
          logger.error(serverMessage.join("\n"))
        }
      } catch (e) {
        logger.error("Error when submitting missed order error", e)
      }
    })
  )

  // init nostojs queue
  logger.info(
    `Nosto client script element added to dom order_id: ( ${checkout.order_id} ), sessionId: ( ${sessionId} )`
  )
  logger.info(`Nosto client script loaded. order_id: ( ${checkout.order_id} ), sessionId: ( ${sessionId} )`)
  nostojs(api => api.loadRecommendations())
  return true
}
